import TcModal from "./index.vue";

export default TcModal;
